module.exports = __webpack_public_path__ + "img/email-icon.669a9d27.png";